import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Contact from './components/Contact';
import Footer from './components/Footer';
import './styles/ThemeManager.css';
import SEOSection from "./components/SEOSection";

function App() {
    return (
        <div>
            <Navbar/>
            <div className="part"> </div>
            <Hero/>
            <About/>
            <hr className="separator"/>
            <Services/>
            <hr className="separator"/>
            <Contact/>
            <hr className="separator"/>
            <SEOSection/>
            <Footer/>
        </div>
    );
}

export default App;
